export default {
  ACTIVE: 'A',
  STOPPED: 'S',
  NEUTRAL: 'N',
  DELETED: 'D',
};
